import React, { forwardRef } from "react";
import { classNames } from "../utils/classNames";
import { useFlexStyles } from "./Flex.styles";
export const Flex = forwardRef((props, contentRef) => {
    let Element = props?.elementType ?? "div";
    return (React.createElement(Element, { className: classNames(useFlexStyles(props).flex), role: props?.role, "aria-label": props["aria-label"], "aria-details": props["aria-details"], ref: contentRef }, props?.children));
});
